import { useState, useEffect } from 'react';
import { saveToStorage, loadFromStorage } from '../services/storageService';

/**
 * Custom hook for managing state that persists in localStorage
 * @param {string} key - The key to store the data under in localStorage
 * @param {any} initialValue - The initial value to use if no value exists in localStorage
 * @returns {Array} [storedValue, setValue] - State and setter function
 */
const useLocalStorage = <T>(key: string, initialValue: T): [T, (value: T) => void] => {
  // Get the initial value from localStorage or use the provided initialValue
  const [storedValue, setStoredValue] = useState<T>(() => {
    return loadFromStorage(key, initialValue);
  });

  // Update localStorage when the state changes
  useEffect(() => {
    saveToStorage(key, storedValue);
  }, [key, storedValue]);

  // Return the state and a wrapper function that updates both state and localStorage
  return [storedValue, setStoredValue];
};

export default useLocalStorage;
